import React from 'react';
import { Alert } from '..';

export default function ErrorMessage({ inset, children}) {
    return <Alert type="error">{children}</Alert>
}